/* Lumoza — barre d'achat collante, 01/09/2026 · regle revue le 07/09/2026.
   Regle : la barre n'apparait QU'A PARTIR du moment ou le bloc d'achat
   principal a ete DEPASSE (sorti par le haut du viewport). Elle reste
   masquee a l'arrivee sur la page, meme si le bouton principal est encore
   plus bas — pour ne jamais afficher le prix des le premier ecran mobile.
   Elle se remasque des qu'on remonte au niveau du bloc d'achat.
   Pilote la classe 'lz-on' (voir lumoza-fix-0109.css) ; la classe
   'is-on' de l'ancien script devient sans effet. */
(function () {
  function init() {
    var bar = document.querySelector('.lz-sticky');
    var form = document.querySelector('#lz-atc-form');
    if (!bar || !form) return;

    var tick = false;
    function update() {
      tick = false;
      var r = form.getBoundingClientRect();
      // « depasse » = le bas du bloc d'achat est passe au-dessus du viewport.
      // Tant que le bloc est a l'ecran OU encore plus bas, la barre reste masquee.
      var passed = r.bottom <= 0;
      bar.classList.toggle('lz-on', passed);
    }
    function onScroll() {
      if (tick) return;
      tick = true;
      (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('orientationchange', onScroll);
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', onScroll); }
    update();
    setTimeout(update, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
